import { useMutation } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
export const useTransferToNewDomain = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    return useMutation(() => client.network.transferToNewDomain(), useMutationOptions);
};
//# sourceMappingURL=useTransferToNewDomain.js.map